/*
 * Copyright (C) 2015 - 2018 Kosmos contact@kosmos.fr
 *
 * Projet: webapp-front
 * Version: 7.4.0-ALPHA-4
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *         http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Initialise l'historique navigateur pour gérer l'état de la page sur les éléments volatils (chargés dynamiquement).
 *
 * @param {string} elementSelector sélecteur js pour identifier l'élément à pousser dans l'historique
 * @param {function} [onStatePopped] fonction appelée quand l'état est rechargé
 */
export function initHistoryManager(elementSelector, onStatePopped = null) {
  history.replaceState({container: document.querySelector(elementSelector).innerHTML}, null, window.location);

  window.addEventListener('popstate', (event) => {
    if (event.state && event.state.container) {
      document.querySelector(elementSelector).innerHTML = event.state.container;
      if (onStatePopped instanceof Function) {
        onStatePopped();
      }
    }
  });
  return {

    /**
     * Charge un état à restaurer dans l'historique.
     * @param {string | URL | null} url nouvelle url
     */
    pushState({url}) {
      history.pushState({container: document.querySelector(elementSelector).innerHTML}, null, url);
    }
  }
}
